import { FetchResult } from '@apollo/client';

import admanToast from '../../components/Alert/util/admanToast';

const handleGqlResponseError = <T>(data: FetchResult<T>, errorMessage: string): boolean => {
  if (data?.errors) {
    admanToast.error(errorMessage);
    return false;
  }
  return true;
};

export default handleGqlResponseError;
